import React, { useState } from "react";
import {  useDispatch } from "react-redux";
import {
  loadingToggleAction,
  ProsignupAction,
} from "../../store/actions/AuthActions";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import PageTitle from "../Layout/PageTitle";

var bnr = require("./../../images/banner/bnr2.jpg");

function ProfessionalSignup(props) {
  let errorsObj = {
    first_name:"",
    last_name:"",
    address: "",
    phone_number: "",
    email: "",
    password: "",
    confirm_password: "",
    zipcode: "",
    jobtitle: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [first_name, setfirst_name] = useState("");
  const [last_name, setlast_name] = useState("");
  const [address, setAddress] = useState("");
  const [phone_number, setPhonenumber] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm_password, setconfirm_password] = useState("");
  const [zipcode, setzipcode] = useState("");
  const [jobtitle, setjobtitle] = useState("");
  const dispatch = useDispatch();

  const onSignUp = (e) => {
    e.preventDefault();
    let error = false;
    const errorObj = { ...errorsObj };
    if (email === "") {
      errorObj.email = "Email is Required";
      error = true;
    }
    if (password === "") {
      errorObj.password = "Password is Required";
      error = true;
    }
    if (confirm_password !== password) {
      errorObj.confirm_password =
        "The password confirmation does not match.";
      error = true;
    }
    if (last_name === "") {
      errorObj.last_name = "Please select your last_name";
      error = true;
    }
    if (first_name === "") {
      errorObj.first_name = "Please select your first_name";
      error = true;
    }
    if (address === "") {
      errorObj.address = "Required";
      error = true;
    }
    if (phone_number === "") {
      errorObj.phone_number = "Required";
      error = true;
    } else {
      var mobPattern = /^\d{10}$/;
      if (!mobPattern.test(phone_number)) {
        error = true;
        errorObj.phone_number = "Invalid phone number. Must be 10 Characters";
      }
    }
    if (zipcode === "") {
      errorObj.zipcode = "Please Enter Your zip code";
      error = true;
    }
    if (jobtitle === "") {
      errorObj.date = "Please Enter Your job title";
      error = true;
    }
    setErrors(errorObj);
    if (error) return;
    dispatch(loadingToggleAction(true));
    dispatch(
      ProsignupAction(
        first_name,
        last_name,
        address,
        phone_number,
        email,
        password,
        confirm_password,
        zipcode,
        jobtitle,
        props.history
      )
    );
  };
  return (
    <>
      <Header />
      <div className="page-content">
        <div
          className="dez-bnr-inr overlay-black-middle bg-pt"
          style={{ backgroundImage: `url(${bnr})` }}
        >
          <PageTitle motherName="Login" activeName="Register" />
        </div>
        <div className="section-full content-inner browse-job shop-account">
          <div className="container">
            <div className="row">
              <div className="col-md-12 m-b30">
                <div className="p-a30 job-bx max-w500 radius-sm bg-white m-auto">
                  <div className="tab-content">
                    <form id="login" className=" ">
                      <h4 className="font-weight-700 m-b5">
                        PERSONAL INFORMATION
                      </h4>
                      <p className="font-weight-600">
                        If you have an account with us, please log in.
                      </p>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <input
                              value={first_name}
                              type="text"
                              className="form-control"
                              placeholder="Enter last_name"
                              defaultValue="first_name"
                              onChange={(e) => setfirst_name(e.target.value)}
                            />
                            <div className="text-danger">
                              {errors.first_name && <div>{errors.first_name}</div>}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <input
                              value={last_name}
                              type="text"
                              className="form-control"
                              placeholder="Enter last_name"
                              defaultValue="last_name"
                              onChange={(e) =>
                                setlast_name(e.target.value)
                              }
                            />
                            <div className="text-danger">
                              {errors.last_name && (
                                <div>{errors.last_name}</div>
                              )}
                            </div>
                          </div>
                        </div>
                        
                      </div>
                      <div className="form-group">
                        <input
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          type="email"
                          className="form-control"
                          placeholder="hello@example.com"
                        />
                        <div className="text-danger">
                          {errors.email && <div>{errors.email}</div>}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <input
                              value={password}
                              type="password"
                              className="form-control"
                              placeholder="Enter Password"
                              defaultValue="Password"
                              onChange={(e) => setPassword(e.target.value)}
                            />
                            <div className="text-danger">
                              {errors.password && <div>{errors.password}</div>}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <input
                              value={confirm_password}
                              type="password"
                              className="form-control"
                              placeholder="Enter Password"
                              defaultValue="confirm_password"
                              onChange={(e) =>
                                setconfirm_password(e.target.value)
                              }
                            />
                            <div className="text-danger">
                              {errors.confirm_password && (
                                <div>{errors.confirm_password}</div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Phone Number"
                              defaultValue="phonenumber"
                              onChange={(e) => setPhonenumber(e.target.value)}
                            />
                            <div className="text-danger">
                              {errors.phone_number && (
                                <div>{errors.phone_number}</div>
                              )}
                            </div>
                          </div>
                        </div>
                      
                        <div className="col-md-12">
                          <div className="form-group">
                            <input
                              value={address}
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              onChange={(e) => setAddress(e.target.value)}
                            />
                            <div className="text-danger">
                              {errors.address && <div>{errors.address}</div>}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <input
                              type="text"
                              value={jobtitle}
                              className="form-control"
                              placeholder="jobtitle"
                              onChange={(e) => setjobtitle(e.target.value)}
                            />
                            <div className="text-danger">
                              {errors.jobtitle && <div>{errors.jobtitle}</div>}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Name Of zipcode"
                              onChange={(e) => setzipcode(e.target.value)}
                            />
                            <div className="text-danger">
                              {errors.zipcode && (
                                <div>{errors.zipcode}</div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-group">
                        <button
                          type="submit"
                          className="site-button btn-block dz-xs-flex m-r5"
                          onClick={onSignUp}
                        >
                          Sign up
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
export default ProfessionalSignup;
